import dynamic from 'next/dynamic';
import { HotelInformationProps } from './HotelInformationComponent';

export const HotelInformationMGP = dynamic<HotelInformationProps>(() => import('./HotelInformationComponent'));
